import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { GraphMeasure } from '../../../../../types/graph-data.interface';

@Component({
  selector: 'app-measure-chip',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslocoModule],
  templateUrl: './measure-chip.component.html',
})
export class MeasureChipComponent {
  readonly measure = input.required<GraphMeasure>();
  readonly nameClickable = input(true);
  readonly change = output<void>();
  readonly configure = output<void>();
  readonly remove = output<void>();
}
